var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.04165V11.5755C0.5 11.9466 0.802604 12.2591 1.1901 12.2786C2.46146 12.3437 5.19271 12.6068 6.75 13.664V6.71873C5.22396 5.68488 2.58307 5.40623 1.27708 5.33331C0.853906 5.30988 0.5 5.6354 0.5 6.04165ZM13.0573 5.33331C11.7529 5.40748 9.11719 5.68409 7.61198 6.71587C7.58594 6.71873 7.58333 6.72133 7.58333 6.72654V13.6666C9.14688 12.6148 11.8724 12.3448 13.1432 12.2791C13.5313 12.2578 13.8333 11.9453 13.8333 11.5755V6.04165C13.8333 5.6354 13.4792 5.30988 13.0573 5.33331ZM9.66667 2.83331C9.66667 1.4531 8.54688 0.333313 7.16667 0.333313C5.78646 0.333313 4.66667 1.4531 4.66667 2.83331C4.66667 4.21352 5.78646 5.33331 7.16667 5.33331C8.54688 5.33331 9.66667 4.21352 9.66667 2.83331Z",
    fill: "#A4AFC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.dd580ad8a561ff9378f8db4f2a59d3dd.svg";
export { ForwardRef as ReactComponent };